module.exports = __webpack_public_path__ + "static/media/top-nfts-7.608e768d.jpg";